import script from "./personal.vue?vue&type=script&setup=true&lang=js"
export * from "./personal.vue?vue&type=script&setup=true&lang=js"

import "./personal.vue?vue&type=style&index=0&id=4e021b22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.12_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e021b22"]])

export default __exports__